import { render, staticRenderFns } from "./ChangeOrganizationAndDepartmentReservation.vue?vue&type=template&id=46785f9c&"
import script from "./ChangeOrganizationAndDepartmentReservation.vue?vue&type=script&lang=js&"
export * from "./ChangeOrganizationAndDepartmentReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports